export const convertToMinutes = (time) => {
  const [hours, minutes] = time.split(":").map(Number);
  return hours * 60 + minutes;
};

// export const getPositionFromTime = (start, end) => {
//   const START_HOUR = 9; // grid starts at 9 AM
//   const PIXELS_PER_MIN = 80 / 60;

//   const startMinutes = convertToMinutes(start);
//   const endMinutes = convertToMinutes(end);

//   const top = (startMinutes - START_HOUR * 60) * PIXELS_PER_MIN;
//   const height = (endMinutes - startMinutes) * PIXELS_PER_MIN;

//   return { top, height };
// };

export const getPositionFromTime = (start, end) => {
  const START_HOUR = 9;
  const TOTAL_HOURS = 24;
  const PIXELS_PER_MIN = 80 / 60;
  const TOTAL_MINUTES = TOTAL_HOURS * 60;

  const startMinutes = convertToMinutes(start);
  const endMinutes = convertToMinutes(end);

  // Offset from grid start (9 AM), wrapping around midnight
  const gridStartMinutes = START_HOUR * 60;

  const startOffset = (startMinutes - gridStartMinutes + TOTAL_MINUTES) % TOTAL_MINUTES;
  const endOffset = (endMinutes - gridStartMinutes + TOTAL_MINUTES) % TOTAL_MINUTES;

  const top = startOffset * PIXELS_PER_MIN;
  const height = (endOffset - startOffset) * PIXELS_PER_MIN;

  return { top, height };
};

export const minutesToTime = (minutes) => {
  const h = Math.floor(minutes / 60);
  const m = minutes % 60;

  return `${String(h).padStart(2, "0")}:${String(m).padStart(2, "0")}`;
};

export const timeToMinutes = (time) => {
  const [h, m] = time.split(":").map(Number);
  return h * 60 + m;
};
